import { useEffect } from "react";

export default function useSkinRedirect() {
  useEffect(() => {
    const url = new URL(window.location.href);
    const pathname = url.pathname;
    const searchParams = url.searchParams;
    const skin = searchParams.get("skin");

    const isSoaringSkin = skin === "soaring";
    const isGame101 = pathname.includes("/crash/101/");
    console.log("IS SOARING SKIN", isSoaringSkin)
    console.log("IS GAME 101", isGame101)
    
    if (isSoaringSkin && isGame101) {
      searchParams.delete("skin");
      const newPathname = pathname.replace("/crash/101/", "/crash/111/");
      const newUrl = `${url.origin}${newPathname}?${searchParams.toString()}`;
      window.location.replace(newUrl);
    }
  }, []);
}
